import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import( /* webpackChunkName: "Login" */ './views/Login.vue')
    },
    {
      path: '/login/:from',
      name: 'login',
      component: () => import( /* webpackChunkName: "Login" */ './views/Login.vue')
    },
    {
      path: '/contest/:id',
      name: 'contest',
      component: () => import( /* webpackChunkName: "Contest" */ './views/Contest.vue')
    },
    {
      path: '/contest/:id/join',
      name: 'join-contest',
      meta: {
        requiresAuth: true
      },
      component: () => import( /* webpackChunkName: "Contest" */ './views/Contest.vue')
    },
    {
      path: '/teams',
      name: 'teams',
      component: () => import( /* webpackChunkName: "Teams" */ './views/Teams.vue')
    },
  ]
})
